import { render } from "./ParticleBackground.vue?vue&type=template&id=4348cf79&scoped=true"
import script from "./ParticleBackground.vue?vue&type=script&lang=js"
export * from "./ParticleBackground.vue?vue&type=script&lang=js"

import "./ParticleBackground.vue?vue&type=style&index=0&id=4348cf79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4348cf79"]])

export default __exports__